export default "__VITE_PUBLIC_ASSET__025253c1__"